import React from 'react';
import { bool, node, shape, string } from 'prop-types';

import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './field.module.css';

const Field = props => {
    const { children, id, label, optional } = props;
    const classes = useStyle(defaultClasses, props.classes);
    const optionalSymbol = optional ? (
        <span className={classes.optional}>Optional</span>
    ) : null;

    const labelBlock =
        label || optionalSymbol ? (
            <label className={classes.label} htmlFor={id}>
                {label}
                {optionalSymbol}
            </label>
        ) : null;

    return (
        <div className={classes.root}>
            {labelBlock}
            {children}
        </div>
    );
};

Field.propTypes = {
    children: node,
    classes: shape({
        label: string,
        root: string
    }),
    id: string,
    label: node,
    optional: bool
};

export default Field;
